import { Injectable, Inject, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, shareReplay, catchError } from 'rxjs/operators';
import { FaqItem } from './faq.model';

// Typed environment token for DI
export interface Environment {
  public: {
    useMockFaq: boolean;
  };
}

export const ENV = new InjectionToken<Environment>('ENV');

@Injectable({ providedIn: 'root' })
export class FaqService {
  private cache$: Observable<FaqItem[]> | null = null;

  constructor(
    private http: HttpClient,
    @Inject(ENV) private env: Environment
  ) {}

  loadAll(): Observable<FaqItem[]> {
    if (!this.cache$) {
      type FaqResponse = FaqItem[] | { items: FaqItem[] };
      const url = this.env.public.useMockFaq ? 'assets/data/faq.json' : '/api/v1/public/faq';
      const obs = this.http.get<FaqResponse>(url);
      this.cache$ = obs.pipe(
        map((res: FaqResponse) => Array.isArray(res) ? res : (res.items ?? [])),
        map((items: FaqItem[]) => items.slice().sort((a, b) => (a.order ?? 999) - (b.order ?? 999))),
        shareReplay(1),
        catchError(err => {
          console.error('FAQ load error', err);
          return of([] as FaqItem[]);
        })
      );
    }
    return this.cache$;
  }

  // For testing or when data changes
  clearCache(): void {
    this.cache$ = null;
  }
}